import { get, post, put, patch, del } from '../util/http';
import { ENDPOINTS } from '../util/endpoints';

export const partnerService = {
  list:          (params)             => get(ENDPOINTS.partners.list, { params }),
  getByUuid:     (uuid, params)       => get(ENDPOINTS.partners.byUuid(uuid), { params }),
  create:        (data)               => post(ENDPOINTS.partners.list, data),
  update:        (uuid, data)         => put(ENDPOINTS.partners.byUuid(uuid), data),
  remove:        (uuid)               => del(ENDPOINTS.partners.byUuid(uuid)),
  activate:      (uuid)               => patch(ENDPOINTS.partners.activate(uuid)),
  deactivate:    (uuid)               => patch(ENDPOINTS.partners.deactivate(uuid)),
  updateToken: (uuid, data)  => patch(ENDPOINTS.partners.token(uuid), data),
  createLicense: (uuid, data)         => post(ENDPOINTS.partners.licenses(uuid), data),
  deleteLicense: (uuid, lUuid)        => del(ENDPOINTS.partners.licenseById(uuid, lUuid)),
  renewLicense:  (uuid, lUuid, data)  => patch(ENDPOINTS.partners.licenseRenew(uuid, lUuid), data),
};
